import clsx from 'clsx'
import React, { useState } from 'react'
import DynamicLink from '../atoms/DynamicLink'

const M15Table = ({ id, table, bottomText, button, anchorLinkId }) => {
  const [openToolTipsOnMobile, setOpenToolTipsOnMobile] = useState([])
  const tableHeader = table.length > 0 ? table[0] : false
  const tableBody = table.length > 1 ? table.slice(1) : false
  const tableHeaderRowReversed = Array.isArray(tableHeader?.row)
    ? [...tableHeader.row].reverse()
    : []

  const setOrUpdateToolTip = (key, value) => {
    setOpenToolTipsOnMobile(prevState =>
      prevState[key] === value
        ? { ...prevState, [key]: undefined }
        : { ...prevState, [key]: value },
    )
  }

  return (
    <section className="my-10 overflow-hidden md:my-20" id={anchorLinkId}>
      <div className="container">
        <div className="row-type-g">
          <div className="pb-10 col-1-type-g1">
            {tableHeader && tableBody && (
              <table className="w-full overflow-hidden bg-black shadow-box rounded-5">
                <thead className="overflow-hidden">
                  {tableHeaderRowReversed
                    .filter(({ copy }) => copy)
                    .map(({ id, copy }, columnIndex) => (
                      <tr
                        key={id}
                        className="md:hidden leading-tight border-x-[20px] sm:border-x-[28px] bg-black border-x-black"
                      >
                        <th
                          colSpan={tableHeader.row.length - columnIndex - 1}
                          className={clsx(
                            'relative u-p-small translate-x-8 sm:translate-x-8 text-right px-1 py-6 font-bold text-white bg-black',
                            {
                              'pb-2': columnIndex === 0,
                              'pt-2': columnIndex > 0,
                            },
                          )}
                        >
                          <span className="relative">
                            {copy}
                            <span className="absolute block w-px translate-y-1 bg-white top-full right-1 h-44"></span>
                          </span>
                        </th>
                      </tr>
                    ))}

                  <tr className="hidden md:table-row leading-tight border-x-[20px] sm:border-x-[28px] lg:border-x-[40px] bg-black border-x-black">
                    {tableHeader.row.map(({ id, copy }, columnIndex) => (
                      <th
                        key={id}
                        className={clsx(
                          'u-p-small px-1 sm:px-3 sm:py-7 font-bold text-white text-left bg-black py-6 md:py-5 xl:py-6',
                          {
                            'max-w-xs xl:max-w-md pr-12 md:pr-12 xl:pr-12':
                              columnIndex === 0,
                            'max-w-[64px] md:max-w-[220px] xl:max-w-[250px]':
                              columnIndex > 0,
                          },
                        )}
                      >
                        <span>{copy}</span>
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {tableBody.map(({ id, row }) => {
                    const rowsWithTooltip = row
                      .map((item, index) => ({ ...item, position: index + 1 }))
                      .filter(item => 'tooltipCopy' in item)

                    return (
                      <React.Fragment key={id}>
                        <tr
                          className={clsx(
                            'leading-tight border-x-[20px] sm:border-x-[28px] lg:border-x-[40px] bg-white border-x-white',
                            {
                              'border-b border-b-gray-4':
                                !rowsWithTooltip.length,
                            },
                          )}
                        >
                          {row.map(
                            (
                              { id: colId, copy, active, tooltipCopy },
                              columnIndex,
                            ) => (
                              <td
                                key={colId}
                                className={clsx('relative u-p-small min-h-[56px] lg:min-h-[64px]', [
                                  !tooltipCopy &&
                                    columnIndex === 0 &&
                                    ' pl-1 sm:pl-3',
                                  columnIndex === 0
                                    ? 'max-w-xs xl:max-w-md pr-12 md:pr-12 xl:pr-12'
                                    : 'max-w-[64px] md:max-w-[220px] xl:max-w-[250px]',
                                  rowsWithTooltip.length
                                    ? 'pt-2 sm:pt-4'
                                    : 'h-16 py-4 sm:py-7',
                                  tooltipCopy &&
                                    rowsWithTooltip.length &&
                                    'align-bottom md:align-top pl-0',
                                  copy && rowsWithTooltip.length && 'pb-4',
                                ])}
                              >
                                {copy && <span>{copy}</span>}
                                {tooltipCopy && (
                                  <div className="flex justify-center md:justify-start">
                                    <span
                                      className={clsx(
                                        'w-full md:w-auto p-2 md:p-0 rounded-t-5 translate-y-1 md:translate-y-0 cursor-pointer md:cursor-default',
                                        {
                                          'bg-gray-3 md:bg-transparent':
                                            openToolTipsOnMobile[id] === colId,
                                        },
                                      )}
                                    >
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="22"
                                        height="22"
                                        fill="none"
                                        viewBox="0 0 22 22"
                                        className="mx-auto md:mx-0 min-w-[22px] relative md:mr-1"
                                        onClick={() =>
                                          setOrUpdateToolTip(id, colId)
                                        }
                                      >
                                        <path
                                          fill="#000"
                                          d="M19.315 14.444a9 9 0 10-16.63-6.888 9 9 0 0016.63 6.888z"
                                        ></path>
                                        <path
                                          fill="#fff"
                                          d="M9.798 9.633h2.74L11.742 16H9l.798-6.367zM11.455 6c.448 0 .818.123 1.109.37.29.238.436.566.436.985 0 .23-.041.43-.125.603a1.242 1.242 0 01-.336.431 1.433 1.433 0 01-.498.259 2.022 2.022 0 01-1.171 0 1.597 1.597 0 01-.5-.259 1.242 1.242 0 01-.336-.43 1.375 1.375 0 01-.124-.604c0-.419.145-.747.436-.986.299-.246.668-.369 1.109-.369z"
                                        ></path>
                                      </svg>
                                    </span>
                                    <span className="hidden md:block">
                                      {tooltipCopy}
                                    </span>
                                  </div>
                                )}
                                {active && (
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="22"
                                    height="22"
                                    fill="none"
                                    viewBox="0 0 22 22"
                                    className="relative mx-2 md:mx-0"
                                  >
                                    <path
                                      stroke="#000"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      strokeWidth="2"
                                      d="M6 10.963L9.357 14.5 16 7.5"
                                    ></path>
                                  </svg>
                                )}
                                {active === false && (
                                  <svg
                                    width="22"
                                    height="22"
                                    viewBox="0 0 22 22"
                                    fill="none"
                                    className="relative mx-2 md:mx-0"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      fillRule="evenodd"
                                      clipRule="evenodd"
                                      d="M6.29289 14.2929C5.90237 14.6834 5.90237 15.3166 6.29289 15.7071C6.68342 16.0976 7.31658 16.0976 7.70711 15.7071L11 12.4142L14.2929 15.7071C14.6834 16.0976 15.3166 16.0976 15.7071 15.7071C16.0976 15.3166 16.0976 14.6834 15.7071 14.2929L12.4142 11L15.7071 7.70711C16.0976 7.31658 16.0976 6.68342 15.7071 6.29289C15.3166 5.90237 14.6834 5.90237 14.2929 6.29289L11 9.58579L7.70711 6.29289C7.31658 5.90237 6.68342 5.90237 6.29289 6.29289C5.90237 6.68342 5.90237 7.31658 6.29289 7.70711L9.58579 11L6.29289 14.2929Z"
                                      fill="#C8C8C8"
                                    />
                                  </svg>
                                )}
                                {!rowsWithTooltip.length && (
                                  <span className="w-full h-[1px] bg-gray-4 absolute bottom-[-1px] left-0 right-0"></span>
                                )}
                              </td>
                            ),
                          )}
                        </tr>
                        {rowsWithTooltip.map(
                          ({ id: tipId, tooltipCopy, position }) => (
                            <tr
                              key={tipId}
                              className={clsx(
                                'md:hidden border-b border-b-gray-4 leading-tight border-x-[20px] sm:border-x-[28px] lg:border-x-[40px] bg-white border-x-white',
                                [
                                  openToolTipsOnMobile[id] === tipId
                                    ? 'table-row'
                                    : 'hidden',
                                ],
                              )}
                            >
                              <td
                                className="relative pb-4 text-right border-0 u-p-small sm:pb-7"
                                colSpan={position}
                              >
                                <div className="inline-block p-5 text-left rounded-b-5 rounded-tl-5 bg-gray-3">
                                  {tooltipCopy}
                                </div>
                              </td>
                              {Array.from({
                                length: 3 - position,
                              }).map((_, index) => (
                                <td key={index}></td>
                              ))}
                            </tr>
                          ),
                        )}
                      </React.Fragment>
                    )
                  })}
                </tbody>
                <tfoot>
                  <tr className="bg-white border-x-[20px] sm:border-x-[28px] lg:border-x-[40px] border-x-white">
                    <td
                      colSpan={table[0].row.length}
                      className="px-1 pt-5 pb-8 bg-white u-p-small lg:pb-10 sm:px-3"
                    >
                      {bottomText && (
                        <div className="flex items-center u-p-small">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="22"
                            height="22"
                            fill="none"
                            viewBox="0 0 22 22"
                            className="mr-1 min-w-[22px]"
                          >
                            <path
                              fill="#000"
                              d="M19.315 14.444a9 9 0 10-16.63-6.888 9 9 0 0016.63 6.888z"
                            ></path>
                            <path
                              fill="#fff"
                              d="M9.798 9.633h2.74L11.742 16H9l.798-6.367zM11.455 6c.448 0 .818.123 1.109.37.29.238.436.566.436.985 0 .23-.041.43-.125.603a1.242 1.242 0 01-.336.431 1.433 1.433 0 01-.498.259 2.022 2.022 0 01-1.171 0 1.597 1.597 0 01-.5-.259 1.242 1.242 0 01-.336-.43 1.375 1.375 0 01-.124-.604c0-.419.145-.747.436-.986.299-.246.668-.369 1.109-.369z"
                            ></path>
                          </svg>
                          {bottomText}
                        </div>
                      )}
                      {button.url && (
                        <div className="mt-6 text-center sm:text-right">
                          <DynamicLink link={button} className="u-btn" />
                        </div>
                      )}
                    </td>
                  </tr>
                </tfoot>
              </table>
            )}
          </div>
        </div>
      </div>
    </section>
  )
}

export default M15Table
